<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 footer-right d-flex flex-wrap align-items-center justify-content-between">
            <p class="mb-0 f-w-600">Shining On Safety – Construction Safety Solutions <br> Confidential and Proprietary
                Copyright ©️ Shining On Safety. All Rights Reserved </p>
            <p class="mb-0 f-w-600">About us -
                <a href="https://www.facebook.com/people/Shiningonsafety-Socialmedia/61552907206527/" target="_blank">
                    <i class="fa fa-facebook-square fa-2x me-2"></i>
                </a>
                <a href="https://www.instagram.com/shiningonsafety/" target="_blank">
                    <i class="fa fa-instagram fa-2x me-2"></i>
                </a>
                <!-- <a href="https://twitter.com/" target="_blank">
                    <i class="fa fa-twitter-square fa-2x"></i>
                </a> -->
            </p>
        </div>
    </div>
</div>